export function applyMissingFilters<T>(
    items: T[],
    activeFilters: string[],
    missingCheck: (item: T, filter: string) => boolean
): T[] {
    if (activeFilters.length === 0) return items;
    return items.filter(item =>
        activeFilters.every(filter => missingCheck(item, filter))
    );
}
